import type { ComputedRef } from 'vue';
import { useMediaQuery } from '@vueuse/core';

/**
 * Media query matched by touch screens. Mirrors the `touch:` variant declared in
 * `layers/ui/assets/style/index.css`; keep both in sync.
 */
export const TOUCH_SCREEN_MEDIA_QUERY = '(hover: none)';

/**
 * Whether the primary input cannot hover, i.e. the user is on a touch screen. Hover-revealed
 * controls never appear there, so callers render a permanently visible alternative instead.
 */
export function useTouchScreen(): ComputedRef<boolean> {
	return useMediaQuery(TOUCH_SCREEN_MEDIA_QUERY);
}
